import { SYSAction } from "../../../../../../../_ovlclient/src"
import type { HookScreenNavigateIn_Type } from "../../../../../../../_ovlclient/src/global/hooks"
import { ScreenCurrent } from "../../../../../../../_ovlclient/src/library/screenapi"
import { OfferingMainRefresh } from "./helpers"

const HookScreenRefresh: SYSAction = async (_, { global }) => {
  let state = global.getState()
  await OfferingMainRefresh(state, undefined, ScreenCurrent())
}

const HookScreenNavigateIn: SYSAction<HookScreenNavigateIn_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()

  state.app.features.QUTOffering.offerMainType = value.instance

  await OfferingMainRefresh(
    state,
    undefined,
    value.screen,
    value.navDirection === "Back" && value.fromScreen === "QUTOfferingDetails"
  )
}

let hooks = { HookScreenRefresh, HookScreenNavigateIn }

export let QUTOfferingAdminCut = { hooks }
export let QUTOfferingAdmin = { hooks }
export let QUTOffering = { hooks }
